import RestoreModal from './RestoreModal';

export default RestoreModal;
